export const fields = {
    columns: {
        username: null,
        email: null,
        password: null,
        password_confirmation: null,
        first_name: null,
        last_name: null,
        nickname: null,
        phone: null, 
        roles: ['user'],
    },

    systemRoles: ['user','Öğrenci', 'Akademisyen', 'İdari Admin', 'SKS Admin', 'admin'],
    systemGenders: ['erkek', 'kadın'],
}